import React from 'react';
import ReleaseCard from './ReleaseCard';

export default function ReleaseV1104({ createThumbnail }) {
  return (
    <ReleaseCard version="v1.10.4" date="22nd May 2026"
        title="Fresh look, fresh features & now you can select a different blind alert sound!">
      <p className="text-gray-300 mb-4">A big one! Poppy Poker gets a visual overhaul and a stack of quality-of-life improvements. Here's what's new:</p>
      <div className="mb-6">
        <h5 className="text-lg font-medium text-purple-400 mb-2">Major GUI Revamp</h5>
        <p className="text-gray-300 mb-4">
          The entire interface has been refreshed with a cleaner, more modern design. Everything from navigation to game screens has been polished for a better experience.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">Edit Club & Game Details</h5>
        <p className="text-gray-300 mb-4">
          Admins can now edit club and game details directly — no more deleting and recreating when something needs to change. Quick, simple, and long overdue!
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">User Preferences</h5>
        <p className="text-gray-300 mb-4">
          A brand new preferences section has been added to the user profile screen, giving you more control over how the app behaves for you.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">Blind Level Sound Notifications</h5>
        <p className="text-gray-300 mb-4">
          Never miss a blind level change again! New sound notifications alert you when the blinds go up so you can stay focused on the game.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">Simplified Admin Promotion</h5>
        <p className="text-gray-300 mb-4">
          A new "Make someone admin" button on the club screen makes it easy to grant admin access — no more digging through menus.
        </p>

        <h5 className="text-lg font-medium text-purple-400 mb-2">Bug Fixes & Stability</h5>
        <p className="text-gray-300 mb-4">
          Small bug fixes and backend session maintenance to keep things running smoothly and reliably.
        </p>
      </div>
    </ReleaseCard>
  );
}
